import React, { FC } from 'react';
import { Redirect, Route } from 'react-router-dom';

import useIsFeatureEnabled from 'src/presentation/hooks/useIsFeatureEnabled';

type PageRouteProps = {
  page: any;
  path: string;
  roleFeature?: string;
  featureFlag?: string;
};
const PageRoute: FC<PageRouteProps> = ({ page, path, roleFeature, featureFlag }) => {
  const Page = page;
  const isFeatureEnabled = useIsFeatureEnabled();
  const hasRole = !roleFeature || isFeatureEnabled(roleFeature);
  const isEnabled = !featureFlag || isFeatureEnabled(featureFlag);
  const renderPage = hasRole && isEnabled;
  return (
    <Route
      path={path}
      render={({ match: { url } }) => {
        return renderPage ? <Page root={url} /> : <Redirect to="/home" />;
      }}
    />
  );
};
export default PageRoute;
